import React from 'react';
import PropTypes from 'prop-types';
import { ContextualAlert, Link } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';

const ErrorMessage = function (props) {
  // tryAgainMethod - a callback method, it gets called when try again is clicked
  const { customerErrorMessage, errorTextLocalePath, customClass, tryAgainTextLocalePath, tryAgainMethod } = props;
  return (
    <div className={`sh-error ${customClass}`} data-testid="sh-error-message-container">
      <ContextualAlert type="error" data-testid="sh-error-message">
        <div data-testid="sh-error-message-text">{customerErrorMessage || <Message id={errorTextLocalePath} />}</div>
      </ContextualAlert>
      {/* Try again link will be rendered only if callback method is passed - pass call back method when retry is allowed */}
      {tryAgainTextLocalePath && tryAgainMethod && (
        <div>
          <Link onClick={tryAgainMethod} data-testid="sh-error-message-try-again-link">
            <Message id={tryAgainTextLocalePath} />
          </Link>
        </div>
      )}
    </div>
  );
};

ErrorMessage.propTypes = {
  customerErrorMessage: PropTypes.string,
  errorTextLocalePath: PropTypes.string,
  customClass: PropTypes.string,
  tryAgainTextLocalePath: PropTypes.string,
  tryAgainMethod: PropTypes.func,
};

ErrorMessage.defaultProps = {
  errorTextLocalePath: 'smarthelp.app.errorMessage.label',
  customClass: '',
  tryAgainTextLocalePath: 'smarthelp.app.errorMessage.subLabel',
};

export default ErrorMessage;
